const formatTaxId = (value) => {
  if (!value) return value;

  value = String(value);

  const lastIsDash = value.slice(-1) === "-";

  const taxId = value.replace(/[^\d]/g, "");

  const taxIdLength = taxId.length;

  // Don't change formatting for numbers that are too short
  if (taxIdLength < 3) return `${taxId}${lastIsDash ? "-" : ""}`;

  return `${taxId.slice(0, 2)}-${taxId.slice(2, 9)}`;
};

const validateTaxId = (value) => {
  if (!value) return false;

  const formattedValue = formatTaxId(value);

  if (typeof formattedValue !== "string") return false;

  return formattedValue.length === 10;
};

export { validateTaxId };
export default formatTaxId;
